<template>
  <div class="article-detail">
    <h3>一、佣金比率说明</h3>
    <p>推精灵内所有CPS、CPA均按商家/官方原始比例来计算佣金。</p>
    <p>退款订单（包含部分退款）、维权订单、风控订单均不结算佣金。</p>
    <h3>二、技术服务费说明</h3>
    <p>
      通过推精灵后台自助取链、API接口取链、SaaS产品内推广等方式推广所产生佣金，次月结算时推精灵统一按官方给予与的数据结算，推精灵平台不收取任何技术服务费。
    </p>
    <h3>三、打款与发票说明</h3>
    <p>
      1、一般纳税人：对公结算，提现账号设置为对公账户，提供税率为6%的增值税专用发票（目前饿了么、美团联盟均收取6%的专用发票）。
    </p>
    <p>
      2、小规模纳税人及个人：通过第三方平台计算，扣除6.5%平台服务费（本服务由第三方提供，费率可能会浮动），佣金可结算至个人支付宝或银行卡。
    </p>
    <h3>四、结算时间</h3>
    <p>
      推精灵平台结算时间为次月20号结算，具体结算时间和规则请参考PC后台【活动清单】各自CPS活动说明。
    </p>
    <p>
      例如：酒店活动是按照离店后时间次月结算，即5月预订，6月入住离店，7月结算。
    </p>
    <h3>五、常见问题</h3>
    <p>1、不开发票可以提现吗？</p>
    <p>答：可以提现，个人/个体户</p>
    <p>均可以不提供发票申请结算，具体说明请参考：三、打款与发票说明</p>
    <p>2、发票可以累积多个月一起开吗？</p>
    <p>答：可以累积，支持累积多个月合并开票提现。</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
h3 {
  font-size: 16px;
  font-weight: 700;
}
p {
  margin: 10px 0;
  font-size: 16px;
}

a {
  font-size: 16px;
  color: #4080ff;

  &:hover {
    text-decoration: underline;
  }
}

img {
  max-width: 100%;
}
</style>
